/* eslint-disable @khan/frontend/require-stories -- unit tests are sufficient  */
import * as React from "react";
import {useLayoutEffect, useRef} from "react";

import {addStyle, type StyleType} from "@khanacademy/wonder-blocks-core";

const StyledSpan = addStyle("span");

interface Props {
    element: HTMLElement;
    style?: StyleType;
    onClick?: () => unknown;
}

/**
 * Put a DOM `element` inside a span.
 *
 * This component puts the given DOM `element` inside a span with the given
 * `style` and `onClick` handler. It uses a React ref to mount the selfsame
 * element it's given. This ensures that any event handler functions on the
 * element are preserved.
 */
export function MountInSpan(props: Props): React.ReactElement {
    const {element, style, onClick} = props;
    const containerRef = useRef<HTMLElement>(null);
    useLayoutEffect(() => {
        if (containerRef.current != null) {
            containerRef.current.innerHTML = "";
            containerRef.current.appendChild(element);
        }
    }, [containerRef, element]);
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- TODO: Address a11y error
    return <StyledSpan ref={containerRef} style={style} onClick={onClick} />;
}
